import { Fragment } from "react";
import "react-tooltip/dist/react-tooltip.css";
import ChartNav from "../../../common/ChartNav";
import React, { useState } from "react";
import { useSelector } from "react-redux";

const PatientClinicalCalc = () => {
  const { patient } = useSelector((state) => state.patients);
  const [showMenu, setShowMenu] = useState(true);
  if (!patient) return null;

  return (
    <div className="relative flex flex-col flex-1 gap-4 bg-white pt-5">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <div className="flex flex-1 max-h-[600px]">
            <div className="ml-4 w-full text-2xl font-bold text-gray-800 gap-5 h-full">
            Clinical Calculation Dashboard coming soon
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientClinicalCalc;
